import { Match, match, MatchFunction } from 'path-to-regexp';

import { routingConfig } from '../consts';
import { AppLanguage, RouteGroupName, RouteNameEnum } from '../enums';

export function getRouteNamesByUrl(url: string, language?: AppLanguage): RouteNameEnum[] {
  const items: RouteNameEnum[] = [];
  for (const [routingGroupName, routingGroupDetails] of Object.entries(routingConfig)) {
    for (const [routeName, routeDetails] of Object.entries(routingGroupDetails.children)) {
      if (!language) {
        for (const language of Object.values(AppLanguage)) {
          const parent: string = routingGroupName !== RouteGroupName.Base ? routingGroupDetails.urls[language] : '';
          const urlMatch: MatchFunction<Record<string, string>> = match(`${parent}${routeDetails.urls[language]}`);
          const isMatched: Match<object> | false = urlMatch(url.split('?')[0]);

          if (isMatched) {
            items.push(routeName as RouteNameEnum);
          }
        }
      } else {
        const parent: string = routingGroupName !== RouteGroupName.Base ? routingGroupDetails.urls[language] : '';
        const urlMatch: MatchFunction<Record<string, string>> = match(`${parent}${routeDetails.urls[language]}`);
        const isMatched: Match<object> | false = urlMatch(url.split('?')[0]);

        if (isMatched) {
          items.push(routeName as RouteNameEnum);
        }
      }
    }
  }

  return items;
}
